export function getDiscountPrice(amount, percent) {
  return (amount - (amount / 100) * percent).toFixed(2);
}
